module.exports = __webpack_public_path__ + "img/xisuma-5cb1e70a-40cb-411b-ce71-08d958505b99.png";